import { Record, List } from 'immutable';
import Name from '@famly/vet_common_name';
import Image from '@famly/vet_common_image';
export const StaffGroup = Record({
    employees: List(),
    groupId: '',
    title: '',
});
const fromAPI = (data) => {
    return new StaffGroup({
        ...data,
        id: data.groupId,
        employees: List(data.employees.map((employee) => {
            var _a;
            return ({
                ...employee,
                id: employee.employeeId,
                hasImage: (_a = employee.hasImage) !== null && _a !== void 0 ? _a : true,
                name: Name.fromAPI(employee.name),
                image: Image.fromAPI(employee.image),
            });
        })),
    });
};
const StaffGroupModel = {
    record: StaffGroup,
    default: new StaffGroup(),
    fromAPI,
};
export default StaffGroupModel;
